import {
  requestType,
  succeedType,
  failedType,
  GET_ALL_LOGS,
  GET_USER_LOGS_BY_ID,
  GET_USERS_LOGS,
  GET_APPLICATION_LOGS_BY_ID,
  GET_APPLICATIONS_LOGS,
  GET_ADMINS_LOGS,
  GET_MIGRATION_LOGS,
} from "./../actions/actionTypes";

const initState = {
  all_logs: [],
  user_logs: [],
  users_logs: [],
  application_logs: [],
  applications_logs: [],
  admins_logs: [],
  migration_logs: [],
  getting_logs: false,
};

export const logReducer = (state = initState, action) => {
  switch (action.type) {
    case requestType(GET_ALL_LOGS):
    case requestType(GET_USER_LOGS_BY_ID):
    case requestType(GET_USERS_LOGS):
    case requestType(GET_APPLICATION_LOGS_BY_ID):
    case requestType(GET_APPLICATIONS_LOGS):
    case requestType(GET_ADMINS_LOGS):
    case requestType(GET_MIGRATION_LOGS):
      return {
        ...state,
        getting_logs: true,
      };
    case failedType(GET_ALL_LOGS):
    case failedType(GET_USER_LOGS_BY_ID):
    case failedType(GET_USERS_LOGS):
    case failedType(GET_APPLICATION_LOGS_BY_ID):
    case failedType(GET_APPLICATIONS_LOGS):
    case failedType(GET_ADMINS_LOGS):
    case failedType(GET_MIGRATION_LOGS):
      return {
        ...state,
        getting_logs: false,
      };
    case succeedType(GET_ALL_LOGS):
      return {
        ...state,
        getting_logs: false,
        all_logs: action.all_logs,
      };
    case succeedType(GET_USER_LOGS_BY_ID):
      return {
        ...state,
        getting_logs: false,
        user_logs: action.user_logs,
      };
    case succeedType(GET_USERS_LOGS):
      return {
        ...state,
        getting_logs: false,
        users_logs: action.users_logs,
      };
    case succeedType(GET_APPLICATION_LOGS_BY_ID):
      return {
        ...state,
        getting_logs: false,
        application_logs: action.application_logs,
      };
    case succeedType(GET_APPLICATIONS_LOGS):
      return {
        ...state,
        getting_logs: false,
        applications_logs: action.applications_logs,
      };
    case succeedType(GET_ADMINS_LOGS):
      return {
        ...state,
        getting_logs: false,
        admins_logs: action.admins_logs,
      };
    case succeedType(GET_MIGRATION_LOGS):
      return {
        ...state,
        getting_logs: false,
        migration_logs: action.migration_logs,
      };
    default:
      return state;
  }
};
